async function o(s,n){let r=await fetch(s,n);if(!r.ok){let t=(await r.json())?.error?.message||"An error occurred while fetching the data.",e=new Error(t);throw e.info=t,e.status=r.status,e}return r.json()}export{o as a};
